import { InjectionToken } from '@angular/core';
import { FenceAccessoriesComponent } from '../pages/configurators-2d/fence/accessories/accessories.component';
import { FenceConfigurationComponent } from '../pages/configurators-2d/fence/configuration/configuration.component';
import { FenceEnvironmentComponent } from '../pages/configurators-2d/fence/environment/environment.component';
import { FenceMaterialsComponent } from '../pages/configurators-2d/fence/materials/materials.component';
import { FenceSummaryComponent } from '../pages/configurators-2d/fence/summary/summary.component';
import { FenceService } from '../services/configurators-2d/applications/fence.service';

export const FE_ENVIRONMENT = new InjectionToken(typeof FenceEnvironmentComponent);
export const FE_CONFIGURATION = new InjectionToken(typeof FenceConfigurationComponent);
export const FE_MATERIALS = new InjectionToken(typeof FenceMaterialsComponent);
export const FE_ACCESSORIES = new InjectionToken(typeof FenceAccessoriesComponent);
export const FE_SUMMARY = new InjectionToken(typeof FenceSummaryComponent);

export const FE_SERVICE = new InjectionToken(typeof FenceService);

export const fenceProviders = [
  {
    provide: FE_SERVICE,
    useClass: FenceService,
  },
  {
    provide: FE_ENVIRONMENT,
    useClass: FenceEnvironmentComponent,
  },
  {
    provide: FE_CONFIGURATION,
    useClass: FenceConfigurationComponent,
  },
  {
    provide: FE_MATERIALS,
    useClass: FenceMaterialsComponent,
  },
  {
    provide: FE_ACCESSORIES,
    useClass: FenceAccessoriesComponent,
  },
  {
    provide: FE_SUMMARY,
    useClass: FenceSummaryComponent,
  },
];
